import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
  dialogContainer: {
    textAlign: 'center'
  },
  buttonContainer: {
    marginTop: '50px'
  },
  cancelButton: {
    float: 'left'
  },
  confirmButton: {
    float: 'right',
    color: 'white'
  }
};

class HpDialog extends Component {
  render() {
    const {
      classes,
      infoText,
      isOpen,
      cancelText,
      confirmText,
      onClose,
      onConfirm
    } = this.props;

    return (
      <React.Fragment>
        <Dialog
          id="payment-info-dialog"
          open={isOpen}
          onClose={onClose}
          disableAutoFocus={true}
          onBackdropClick={onClose}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '250px',
              maxWigth: '350px',
              padding: '20px'
            }
          }}
        >
          <div className={classes.dialogContainer}>
            <Typography variant="h6">{infoText}</Typography>
            <div className={classes.buttonContainer}>
              <Button
                className={classes.cancelButton}
                variant="outline"
                color="secondary"
                onClick={onClose}
              >
                {cancelText}
              </Button>
              <Button
                className={classes.confirmButton}
                variant="contained"
                color="primary"
                onClick={onConfirm}
              >
                {confirmText}
              </Button>
            </div>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(HpDialog);



// WEBPACK FOOTER //
// ./src/components/shared/components/hpDialog.js